module.exports = __webpack_public_path__ + "assets/-_11.33d10f48.svg";